<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
      </router-view>
    </keep-alive>
    <transition name="slide-right">  
      <router-view v-if="!$route.meta.keepAlive && $route.meta.silde"></router-view>  
    </transition> 
    <router-view v-if="!$route.meta.silde && !$route.meta.keepAlive">
    </router-view>
  </div>
</template>

<script>
import { getEnv } from '@/utils/tool'
export default {
  name: 'App',
  mounted() {
    if(getEnv() === 'app') {
      const userInfo = JSON.parse(localStorage.getItem('header_json'))
      if(userInfo && (userInfo.studioid == 16 || userInfo.studioid == 1408)) {
        eruda.init()
      } else if(!userInfo) {
        eruda.init()
      }
      console.log("window.location.href", window.location.href)
    }
  }
}
</script>

<style>
#app {
  font-family: PingFangSC, PingFangSC-Medium;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  background: #F2F2F7;
}
html{
  min-height: 100vh;
  background: #f2f2f2;
  position: relative;
}
*{
  padding: 0;
  margin: 0;
}
h4,p{
  font-size: 16px;
}

.slide-right-enter-active, .slide-right-leave-active {  
  transition: all 0.5s ease;  
  position: absolute;  
  width: 100%;  
}  
.slide-right-enter, .slide-right-leave-to {  
  transform: translateX(100%);  
}  
.slide-right-enter-to, .slide-right-leave {  
  transform: translateX(0);  
}  
</style>



// WEBPACK FOOTER //
// src/App.vue